import { render, staticRenderFns } from "./on-off.vue?vue&type=template&id=1c1d0e5b&"
import script from "./on-off.js?vue&type=script&lang=js&"
export * from "./on-off.js?vue&type=script&lang=js&"
import style0 from "./on-off.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports